import { render } from "./RobotSessionView.vue?vue&type=template&id=3610cf39&scoped=true"
import script from "./RobotSessionView.vue?vue&type=script&lang=js"
export * from "./RobotSessionView.vue?vue&type=script&lang=js"

import "./RobotSessionView.vue?vue&type=style&index=0&id=3610cf39&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3610cf39"]])

export default __exports__